import { useIntl } from '@capsicum/common';

export const useExportAndCloseAccountTransferDrawer = () => {
	const { $t } = useIntl();

	return {
		intlTexts: {
			closeButton: $t('global.button.close'),
			continueButton: $t('settings.accountManagement.exportAndCloseAccountTransferFirstWarning.continue'),
			title: $t('settings.accountManagement.exportAndCloseAccountTransferFirstWarning.title'),
			toWalletButton: $t('settings.accountManagement.exportAndCloseAccountTransferFirstWarning.toWallet')
		},
		smartContractPageUrl:
			'https://socios.zendesk.com/hc/en-001/articles/30835114755345-What-is-the-Smart-Contract-layer-of-the-wallet'
	};
};
